import React from 'react';
import { motion } from 'framer-motion';
import { researchTrace } from '../../data/semanticKnowledge';
import { fadeUp } from '../../utils/motion';
export function SkpResearch() {
  return <section className="bg-surface-bg py-20 lg:py-28" data-id="element-1390" data-mp="ptepoiixn1qe">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16" data-id="element-1391" data-mp="prtzt67kc6yv">
        <motion.div {...fadeUp} className="lg:col-span-5" data-id="element-1392" data-mp="ksr3qb9k9b31">
          <h2 className="font-heading font-bold text-4xl lg:text-5xl text-ink-dark tracking-tight leading-tight mb-6" data-id="element-1393" data-mp="fwa4akwwvaan">
            Built for scientific research
          </h2>
          <p className="text-xl text-ink-dark leading-relaxed mb-6" data-id="element-1394" data-mp="6uaotx1joe9t">
            SKP helps research teams connect studies, researchers,
            organizations, populations, interventions, outcomes, and
            publications.
          </p>
          <p className="text-lg text-ink-muted leading-relaxed" data-id="element-1395" data-mp="21822r8qwpkb2">
            The same semantic workflow supports terminology management,
            literature discovery, evidence mapping, and expert-reviewed
            knowledge graphs across research domains.
          </p>
        </motion.div>

        <motion.div {...fadeUp} className="lg:col-span-7" data-id="element-1396" data-mp="2rvlkequ574uj">
          <div className="bg-white border border-line rounded-lg p-8" data-id="element-1397" data-mp="2dvaubq0npuaf">
            <p className="text-sm font-medium text-teal mb-2" data-id="element-1398" data-mp="2itm4k1uv66t6">A team can ask</p>
            <ol className="relative" data-id="element-1399" data-mp="2ivq7agh10zrv">
              {researchTrace.map((row, index) => <li key={row.label} className="relative flex gap-5 pb-6 last:pb-0" data-id="element-1400" data-mp="36lb15uepxhfx" data-mpi={index}>
                  {index < researchTrace.length - 1 && <span aria-hidden="true" className="absolute left-[5px] top-4 bottom-0 w-px bg-line" data-id="element-1401" data-mp="2wtwvf4w6blec" />}
                  <span className={`relative mt-1.5 w-[11px] h-[11px] rounded-full shrink-0 ${index === researchTrace.length - 1 ? 'bg-navy' : 'bg-white border-2 border-navy-light'}`} data-id="element-1402" data-mp="3pic6jgc6pjke" />
                  <div data-id="element-1403" data-mp="7yc02cv4g25n">
                    <p className="text-xs font-semibold text-ink-muted" data-id="element-1404" data-mp="7yval8ifzo9n">{row.label}</p>
                    <p className="text-lg font-heading font-semibold text-ink-dark" data-id="element-1405" data-mp="31ll5sv1zclt">
                      {row.value}
                    </p>
                  </div>
                </li>)}
            </ol>
            <p className="mt-8 pt-6 border-t border-line text-ink-muted leading-relaxed" data-id="element-1406" data-mp="3p78sgvkg9if8">
              Conflicting findings remain visible for review rather than being
              flattened into a single unsupported conclusion.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}